import {
  RiCheckboxBlankCircleLine,
  RiCheckboxCircleFill,
  RiErrorWarningLine,
  RiLoader4Line,
  RiQuestionLine,
} from '@remixicon/react';
import classNames from 'classnames';

import { TaskState } from '@spotify/plugin-confidence-issues-react';

import { TASK_STATE_LABELS } from './taskUtils';

import styles from './TaskStateIcon.module.css';

const ICON_SIZE = 'var(--encore-graphic-size-decorative-base)';

export type TaskStateIconProps = {
  state: TaskState;
};

export const TaskStateIcon = ({ state }: TaskStateIconProps) => {
  const className = classNames(styles.stateIcon, {
    [styles.openStateIcon]: state === TaskState.Open,
    [styles.inProgressStateIcon]: state === TaskState.InProgress,
    [styles.completedStateIcon]: state === TaskState.Completed,
    [styles.failedStateIcon]: state === TaskState.Failed,
    [styles.waitingForInputStateIcon]: state === TaskState.WaitingForInput,
  });

  if (state === TaskState.Completed) {
    return (
      <span
        className={className}
        role="img"
        aria-label={TASK_STATE_LABELS[state]}
      >
        <RiCheckboxCircleFill size={ICON_SIZE} aria-hidden />
      </span>
    );
  }

  if (state === TaskState.InProgress) {
    return (
      <span
        className={className}
        role="img"
        aria-label={TASK_STATE_LABELS[state]}
      >
        <RiLoader4Line size={ICON_SIZE} aria-hidden />
      </span>
    );
  }

  if (state === TaskState.Failed) {
    return (
      <span
        className={className}
        role="img"
        aria-label={TASK_STATE_LABELS[state]}
      >
        <RiErrorWarningLine size={ICON_SIZE} aria-hidden />
      </span>
    );
  }

  if (state === TaskState.WaitingForInput) {
    return (
      <span
        className={className}
        role="img"
        aria-label={TASK_STATE_LABELS[state]}
      >
        <RiQuestionLine size={ICON_SIZE} aria-hidden />
      </span>
    );
  }

  return (
    <span
      className={className}
      role="img"
      aria-label={TASK_STATE_LABELS[state]}
    >
      <RiCheckboxBlankCircleLine size={ICON_SIZE} aria-hidden />
    </span>
  );
};
